import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";

declare var ko: any;

export class newsletterTemplateImagesList_template extends vnTemplate {

    protected filter!: filterSimple_template;
    protected resultInfos!: resultsInfo_template;
    protected pagination!: pagination_template;

    protected initPartial() {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
    }

    public getViewModelForRequest(): any {

        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters : {
                keywords : this.getTemplateViewModel().filter.filterKeyword
            },
        }
    }

    protected buildViewModel(): any {

        let self = this
        return {
            images: ko.observableArray([]),
            orderBy: ko.observable("id"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("id_ASC"),
            imageToDelete: ko.observable(null),
            onClickReorder: (value: any, data: any, event: any) => {
                self.onClickReorder(value, data, event);
            },
            onClickCancel: () => {
                self.onClickCancel();
            },
            onClickAdd: () => {
                self.onClickAdd();
            },
            onClickEdit: (data: any, event: any) => {
                self.onClickEdit(data);
            },
            onClickShowDeletePopUp: (data: any, event: any) => {
                self.onClickShowDeletePopUp(data);
            },
            onClickHidePopUp: (data: any, event: any) => {
                self.onClickHidePopUp();
            },
            onClickDelete: (data: any, event: any) => {
                self.onClickDelete();
            }
        }
    }

    protected getTemplateHtml(): string {

        return (`
        <div class="list-header w-justify">
            <div class="w-left" >
                <button data-bind="event: {click: onClickCancel}" class="btn icon i-back" type="button">Go Back</button>
                <button data-bind="event: {click: onClickAdd}" class="btn secondary icon i-add" type="button">Add Image</button>
            </div>
            <div class="w-center">
                <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                    <div class="w-search-feild icon i-search2">
                        <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                        <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                        <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                        <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                    </div>
                </div>
            </div>
            <div class="w-right">
                ` + this.pagination.getHtmlBuild() + `
            </div>
        </div>

        <div class="w-list-results w-video-list list-article" id="list-results">
            <table class="list-results">
                ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th class="align-center"><span>Image Preview</span></th>
                            <th><span>Width</span></th>
                            <th><span>Height</span></th>
                            <th><span>Usage Status</span></th>
                            <th><span>Warning</span></th>
                            <th style="width: 10rem;"><span>Action</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: images">
                        <tr class="cursor">
                            <td>
                                <a class="right-click"><span data-bind="text: id"></span></a>
                            </td>
                            <td>
                                <a class="right-click"><span data-bind="text: name"></span></a>
                            </td>
                            <td class="has-image">
                                <a class="right-click">
                                    <img class="thumbnail" data-bind="attr: { src: value ? value + (value.indexOf('?') === -1 ? '?w=120' : '&w=120') : '' }, visible: value"  alt="" />
                                </a>
                            </td>
                            <td>
                                <a class="right-click"><span data-bind="text: width"></span></a>
                            </td>
                            <td>
                                <a class="right-click"><span data-bind="text: height"></span></a>
                            </td>
                            <td>
                                <a class="right-click"><span data-bind="text: usageStatus"></span></a>
                            </td>
                            <td>
                                <a class="right-click"><span class="form-text alert-error" data-bind="visible: hasWidthAndHeight">Width and height are both set in the URL.</span></a>
                            </td>
                            <td>
                                <a class="right-click">
                                    <button type="button" class="btn-form icon icon-only i-edit" data-bind="event: {click: $parent.onClickEdit }"></button>
                                    <button type="button" class="btn-form icon icon-only highlight i-delete" data-bind="disable: isInUse, event: {click: $parent.onClickShowDeletePopUp}, clickBubble: false"></button>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="delete-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Deleting Header Image</h3>
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                        </div>
                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This action is irreversible</p>
                                <p class="form-text">Are you sure you want to delete this header image?</p>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickDelete }" class="btn highlight">Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        `);
    }

    protected getTemplateName(): string {

        return "newsletterTemplateImagesList_template";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-content"];
    }

    protected getMainElementType(): string {

        return "div";
    }

    public setResultInfo(nbResults: any, nbPages: any, execTime: any) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    protected onClickReorder(value: any, data: any, event: any): any {

        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.imagesListReorder();
    }

    protected onClickCancel(): any {

        this.caller.cancel();
    }

    protected onClickAdd(): any {

        this.caller.add();
    }

    protected onClickEdit(data: any): any {

        this.caller.edit(data.id);
    }

    protected onClickShowDeletePopUp(data: any): any {

        this.getTemplateViewModel().imageToDelete(data);
        this.toggleDeleteDialogVisibility();
    }

    protected onClickHidePopUp(): any {

        this.getTemplateViewModel().imageToDelete(null);
        this.toggleDeleteDialogVisibility();
    }

    protected onClickDelete(): any {

        let image = this.getTemplateViewModel().imageToDelete();
        this.toggleDeleteDialogVisibility();
        this.caller.delete(image);
    }

    public toggleDeleteDialogVisibility(): any {

        document.getElementById('delete-dialog')!.classList.toggle('is-visible');
    }

    public setImages(images: any) {

        this.getTemplateViewModel().images(images);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterTemplateImagesList_template.ts